/* Shorae — Tiroir mobile : dépliage animé de l'accordéon.

   Les details natifs s'ouvrent d'un coup. On intercepte le clic sur le
   summary et on anime la hauteur du bloc avec l'API Web Animations.

   Pourquoi WAAPI et pas une transition CSS : une transition émet un
   transitionend qui remonte jusqu'au composant header-menu-drawer du thème.
   WAAPI ne produit aucun événement DOM propagé.

   DEUX PIÈGES, sources de saccades, traités ici :

   1. fill. Sans fill, une animation WAAPI relâche sa valeur dès qu'elle se
      termine, et onfinish n'est appelé qu'ensuite — le navigateur a donc le
      temps de peindre une image à la hauteur naturelle. Au repli, tout le
      contenu reapparait brievement avant de disparaitre. On utilise fill
      'both' : la valeur de départ s'applique avant le début, celle d'arrivée
      persiste après la fin, et on ne libère qu'après avoir figé l'état final.

   2. L'image de trop à l'ouverture. Poser details.open sans avoir d'abord
      contraint la hauteur laisse le bloc à sa taille naturelle. On met la
      hauteur à zéro avant d'ouvrir, tout dans la même tâche, donc sans
      peinture intermédiaire.

   L'attribut data-expanded, posé dès le premier frame, pilote le signe + / −.
   Il ne peut pas dépendre de l'attribut open : à la fermeture, open ne tombe
   qu'à la fin de l'animation, ce qui figerait le signe pendant toute la durée. */

(function () {
  'use strict';

  var DURATION = 320;
  /* Courbe choisie au banc d'essai plutôt qu'au jugé. L'ancienne,
     cubic-bezier(0.22, 1, 0.36, 1), plaçait 22 % du mouvement dans la
     première image puis laissait 100 ms de quasi-immobilité en fin de
     course : ça sautait, puis ça semblait figé. Celle-ci démarre à 0 % et
     ne stagne pas. */
  var EASING = 'cubic-bezier(0.45, 0, 0.25, 1)';
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function drop(details) {
    var child = details.firstElementChild;
    while (child) {
      if (child.classList && child.classList.contains('shorae-dm__drop')) return child;
      child = child.nextElementSibling;
    }
    return null;
  }

  /* Le bloc animé n'a aucun padding ; tout l'espacement vit dans __inner.
     On mesure donc l'intérieur, pas scrollHeight : scrollHeight compte le
     padding là où la propriété height, en content-box, ne le compte pas. */
  function inner(box) {
    return box.firstElementChild;
  }

  function contentHeight(box) {
    var el = inner(box);
    return el ? el.getBoundingClientRect().height : box.scrollHeight;
  }

  function stop(box) {
    if (box.shoraeAnim) {
      box.shoraeAnim.cancel();
      box.shoraeAnim = null;
    }
  }

  function release(box) {
    box.style.height = '';
    box.style.overflow = '';
    box.style.willChange = '';
  }

  function expand(details) {
    /* Le signe bascule tout de suite, en même temps que la hauteur démarre. */
    details.setAttribute('data-expanded', '');

    var box = drop(details);
    if (!box) {
      details.open = true;
      return;
    }

    var from = box.shoraeAnim ? box.getBoundingClientRect().height : 0;
    stop(box);

    if (REDUCE) {
      release(box);
      details.open = true;
      return;
    }

    /* Contraindre AVANT d'ouvrir : aucune image ne sera peinte à la hauteur
       naturelle. Tout ce bloc est synchrone, donc sans peinture intermédiaire. */
    box.style.overflow = 'hidden';
    box.style.willChange = 'height';
    box.style.height = from + 'px';

    details.open = true;

    var to = contentHeight(box);

    var anim = box.animate(
      [{ height: from + 'px' }, { height: to + 'px' }],
      { duration: DURATION, easing: EASING, fill: 'both' }
    );

    box.shoraeAnim = anim;
    anim.oncancel = function () { box.shoraeAnim = null; };

    anim.onfinish = function () {
      box.shoraeAnim = null;
      /* On libère les styles pendant que le fill tient encore la hauteur
         d'arrivée, puis seulement on lâche l'animation. */
      release(box);
      anim.cancel();
    };
  }

  function collapse(details, options) {
    options = options || {};
    details.removeAttribute('data-expanded');

    var box = drop(details);

    if (!box) {
      details.open = false;
      return;
    }

    var from = box.shoraeAnim ? box.getBoundingClientRect().height : contentHeight(box);
    stop(box);

    if (REDUCE || options.instant) {
      release(box);
      details.open = false;
      return;
    }

    box.style.overflow = 'hidden';
    box.style.willChange = 'height';
    box.style.height = from + 'px';

    var anim = box.animate(
      [{ height: from + 'px' }, { height: '0px' }],
      { duration: options.duration || DURATION, easing: EASING, fill: 'both' }
    );

    box.shoraeAnim = anim;
    anim.oncancel = function () { box.shoraeAnim = null; };

    anim.onfinish = function () {
      box.shoraeAnim = null;
      /* open tombe pendant que le fill maintient la hauteur à zéro : le bloc
         passe en display:none sans jamais repasser par sa taille naturelle. */
      details.open = false;
      release(box);
      anim.cancel();
    };
  }

  function onSummary(event) {
    var summary = event.currentTarget;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS') return;

    event.preventDefault();

    if (details.open) {
      collapse(details);
      return;
    }

    /* Premier niveau exclusif : ouvrir une entrée referme la précédente.
       Fait ici plutôt qu'avec l'attribut name, qui referme sans animation. */
    if (details.classList.contains('shorae-dm__acc--root')) {
      var root = details.closest('.shorae-dm');
      if (root) {
        root.querySelectorAll('.shorae-dm__acc--root[open]').forEach(function (other) {
          if (other !== details) collapse(other);
        });
      }
    }

    expand(details);
  }

  /* --- Durée de fermeture du tiroir ---------------------------------------
     Plutôt que de coder une valeur en dur, on lit la durée réellement
     appliquée par le thème, pour que les tiroirs se replient exactement dans
     le même temps que le menu qui les emporte. */

  function parseMs(value) {
    if (!value) return 0;

    return value.split(',').reduce(function (max, part) {
      part = part.trim();
      var amount = parseFloat(part);
      if (isNaN(amount)) return max;
      if (part.indexOf('ms') === -1) amount *= 1000;
      return Math.max(max, amount);
    }, 0);
  }

  function drawerDuration() {
    var drawer = document.getElementById('menu-drawer');
    if (!drawer) return DURATION;

    var candidates = [drawer];

    if (drawer.shadowRoot) {
      ['[part="content"]', '[part="overlay"]'].forEach(function (selector) {
        var el = drawer.shadowRoot.querySelector(selector);
        if (el) candidates.push(el);
      });
    }

    var longest = 0;

    candidates.forEach(function (el) {
      var styles = getComputedStyle(el);
      longest = Math.max(longest, parseMs(styles.transitionDuration), parseMs(styles.animationDuration));
    });

    return longest > 0 ? longest : DURATION;
  }

  /* --- Tout replier ------------------------------------------------------- */

  function openAccordions() {
    return document.querySelectorAll('.shorae-dm__acc[open], .shorae-dm__acc[data-expanded]');
  }

  function collapseAll() {
    var list = openAccordions();
    if (!list.length) return;

    /* Mesuré maintenant : le tiroir est encore affiché, ses styles calculés
       sont donc ceux de l'état ouvert. */
    var duration = drawerDuration();

    list.forEach(function (details) {
      collapse(details, { duration: duration });
    });
  }

  /* --- Détection de la fermeture du tiroir --------------------------------
     On replie au moment où la fermeture est déclenchée, pas après : le thème
     restaure la transparence de l'en-tête dans la foulée. D'où l'écoute en
     phase de capture, qui passe avant les gestionnaires du thème. */

  function watchClose() {
    if (document.documentElement.dataset.shoraeDrawerWatched === 'true') return;
    document.documentElement.dataset.shoraeDrawerWatched = 'true';

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      /* Bouton d'ouverture ou de fermeture du tiroir. */
      if (target.closest('[aria-controls="menu-drawer"]')) {
        collapseAll();
        return;
      }

      /* Clic sur le voile : il vit dans le shadow DOM, l'événement est donc
         redirigé vers l'hôte header-menu-drawer lui-même. */
      if (target.id === 'menu-drawer') {
        collapseAll();
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.key === 'Esc') collapseAll();
    }, true);

    var drawer = document.getElementById('menu-drawer');
    if (!drawer) return;

    /* Filet de sécurité : si le tiroir se ferme par un chemin qu'on n'a pas
       intercepté, sa boîte tombe à zéro. */
    if (typeof ResizeObserver === 'function') {
      var seenWide = false;

      new ResizeObserver(function (entries) {
        var box = entries[0].contentRect;

        if (box.width > 0 && box.height > 0) {
          seenWide = true;
          return;
        }

        if (seenWide) {
          seenWide = false;
          openAccordions().forEach(function (details) {
            collapse(details, { instant: true });
          });
        }
      }).observe(drawer);
    }
  }

  /* Les événements d'animation et de transition nés dans le tiroir ne doivent
     pas remonter jusqu'aux composants du thème. */
  function isolate(root) {
    if (root.dataset.shoraeIsolated === 'true') return;
    root.dataset.shoraeIsolated = 'true';

    ['transitionend', 'animationend'].forEach(function (type) {
      root.addEventListener(type, function (event) { event.stopPropagation(); });
    });
  }

  function setup(scope) {
    (scope || document).querySelectorAll('.shorae-dm').forEach(function (root) {
      root.classList.add('shorae-dm--js');
      isolate(root);
    });

    (scope || document).querySelectorAll('.shorae-dm__acc > summary').forEach(function (summary) {
      if (summary.dataset.shoraeReady === 'true') return;
      summary.dataset.shoraeReady = 'true';
      summary.addEventListener('click', onSummary);
    });
  }

  function init(scope) {
    setup(scope);
    watchClose();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
